import { type FunctionalComponent, h } from '@stencil/core';
import { prepareSubstitutionToolUrl, buildObsoleteProductsObject, substitutionCallback } from '../../../../conversational-search-logic/utils/utils';
import { ConversationalSearchLabelWithSection } from '../../../../conversational-search-partials/label-with-section/label-with-section';
import type { ConversationalSearchProductSuggestions } from '../../../../conversational-search-types/conversational-search-types.type';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';

export interface IConversationalSearchMessagesSuggestionsOutro {
  suggestions: ConversationalSearchProductSuggestions[];
  labelProvider: labelProviderInterface;
  conversationalSearchBrandUrl: string;
  country: string;
  language: string;
  query: string;
}

export const ConversationalSearchMessagesSuggestionsOutro: FunctionalComponent<
  IConversationalSearchMessagesSuggestionsOutro
> = (props) => {
    const obsoleteProductData = buildObsoleteProductsObject(props.suggestions);
    const discontinuedProduct = obsoleteProductData?.commStatuses?.find(item => item?.key === 'DISCONTINUED');
    const outroTextSingleElement = props.labelProvider(
      'conversational.search.suggestions.outro',
      'For more information such as documentation, compatible products, and more, please visit the specific product page by clicking on one of the results above.',
    );

    const outroTextSingleObsoleteElement = props.labelProvider(
      'conversational.search.suggestions.outro.obsolete',
      'Please note, that this product has been discontinued, for a complete listing of all available replacements and related information, consult our {1}.',
    );

    const outroTextSingleObsoleteElementCta = props.labelProvider(
      'conversational.search.suggestions.cta.obsolete',
      'Product Substitution Tool',
    );

    const redirectionUrl = prepareSubstitutionToolUrl(
      props.conversationalSearchBrandUrl,
      props.country,
      props.language,
      obsoleteProductData?.productIds,
    );

    const onClickCallback = () => {
        substitutionCallback(
          redirectionUrl,
          props.query,
          'GenAI_link',
        );
    };

    return (
      <section class="conversational-search-suggestions-outro">
        {discontinuedProduct && props.suggestions?.length === 1 ? (
          <ConversationalSearchLabelWithSection
            text={outroTextSingleObsoleteElement}
          >
            <qds-inline-link
              href={redirectionUrl}
              target='_blank'
              onClick={() => onClickCallback()}
              onKeyDown={(e) => e.key === 'Enter' ? onClickCallback() : void 0}
            >
              {outroTextSingleObsoleteElementCta}
            </qds-inline-link>
          </ConversationalSearchLabelWithSection>
        ) : (
          outroTextSingleElement
        )}
      </section>
    );
};
